var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMute = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16.085"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14770"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 14633"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 6401"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 14634"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.851 2.091a3.6 3.6 0 0 0-1.724-.426h0c-2.126 0-3.364 1.912-3.364 4.037v2.691c0 1.07-.8 1.769-1.346 2.691h0a1.93 1.93 0 0 0 .151 1.954M7.113 13.777h4.378c1.156 0 1.932-1.7 1.346-2.691h0a4.66 4.66 0 0 1-.673-2.691V5.704a4 4 0 0 0-.256-1.332",
  "data-name": "Path 16659"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.306 1.197 4.387 15.062",
  "data-name": "Path 1686"
}))))));
export { SvgMute as ReactComponent };
export default __webpack_public_path__ + "static/media/mute.4bfd88e41d0ce90f77b2fc6d2103d2fb.svg";